import type { UseFormRegisterReturn } from "react-hook-form";
import { LabeledField } from "./LabeledField";
import { inputStyle } from "./FormField";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): el par "Vigente desde" /
// "Vigente hasta" (grilla de dos columnas, mismo hint "Vacío = vigencia
// indefinida.") era el mismo marcado palabra por palabra en
// benefits/BenefitsScreen.tsx, rewards/RewardsScreen.tsx y
// offers/OffersScreen.tsx — cada una con su propio alias de `LabeledField`
// (`BField`/`RField`/`OField`), que ya era el mismo componente (PA-025-E).
// Extracción sin cambio de comportamiento ni de valores visuales: ninguna
// pantalla que la use cambia un pixel por esto.
//
// `untilError`: el rechazo de rango (fin anterior al inicio), del esquema de
// cliente o de la API (`validUntil`), con el mismo `FieldError` del resto de
// los campos.
export function ValidityRangeFields({
  validFrom,
  validUntil,
  untilError,
}: {
  validFrom: UseFormRegisterReturn;
  validUntil: UseFormRegisterReturn;
  untilError?: string | undefined;
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "0 16px",
      }}
    >
      <LabeledField label="Vigente desde">
        <input type="date" {...validFrom} style={inputStyle} />
      </LabeledField>
      <LabeledField
        label="Vigente hasta"
        hint="Vacío = vigencia indefinida."
        error={untilError}
      >
        <input type="date" {...validUntil} style={inputStyle} />
      </LabeledField>
    </div>
  );
}
